
<template>
  <v-container fluid>
    <v-card flat>
      <v-card-text v-if="loading">
        <v-alert type="info" :value="true">
          Carregando dados
          <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
        </v-alert>
      </v-card-text>

      <v-card-text v-if="!loading && !Object.keys(extracts).length">
        <v-alert type="warning" :value="true">
          Sem registros para essa data.
        </v-alert>
      </v-card-text>

      <v-card-text v-if="!loading && Object.keys(extracts).length">
        <div v-for="(val, k) in extracts" :key="k" style="border-radius: 12px; border: solid 1px #ccc" class="mb-2 pa-2 py-4">
          <header-extract :val="val" :day='k'></header-extract>

          <confirmation-extract :val="val" kind='bill' :ref_date="day_selected"> </confirmation-extract>

          <company-extract :val="val" kind='bill'> </company-extract>

        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import extract_mixin from './get_extract_mixin'
import data_extract_mixin from './data_extract_mixin'
import HeaderExtract from './extract/HeaderExtract.vue'
import ConfirmationExtract from './extract/ConfirmationExtract.vue'
import CompanyExtract from './extract/CompanyExtract.vue'

export default {
  components: { HeaderExtract, ConfirmationExtract, CompanyExtract },
  name: 'BillExtract',
  mixins: [extract_mixin, data_extract_mixin],
  props: {
    day_selected: {
      type: String,
    },
  },
  mounted () {
    this.getExtract('bill')
  },
  watch:{
    day_selected(){
      this.getExtract('bill')
    }
  }
}
</script>